<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text extended color="white" extension-height="94px">
                <v-toolbar-title style="width: 60%;">
                    <v-layout flex wrap>
                        <v-flex xs5>
                            Бронирование
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
							<span class="booking-date">
								{{ booking.time | formatDate }}
							</span>
                            <span class="booking-time">
								{{ booking.time | formatTime }}
							</span>
                        </v-flex>
                    </v-layout>
                </v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="sendForm">
                    <v-icon>print</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <div slot="extension" class="w-100 action-btn">
                    <v-btn color="info" @click="confirmRejectBooking(booking.id, 1)" :disabled="booking.state < 0">
                        {{ booking.state === 1 ? 'Подтвержден' : 'Подтвердить' }}
                    </v-btn>
                    <v-btn color="error" @click="confirmRejectBooking(booking.id, -1)" :disabled="booking.state > 0">
                        {{ booking.state === -1 ? 'Отменён' : 'Отменить' }}
                    </v-btn>
                </div>
            </v-toolbar>
            <v-form class="form-add form-add--extended">
                <v-layout flex wrap>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">ID заказа</v-subheader>
                        <span>№ {{ booking.id }}</span>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">Заказчик</v-subheader>
                        <span v-text="booking.customer"></span>
                    </v-flex>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">Номер телефона</v-subheader>
                        <span>{{ booking.phone | formatPhone }}</span>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">Платформа</v-subheader>
                        <span>{{ booking.platform | formatPlatform }}</span>
                    </v-flex>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">Зал</v-subheader>
                        <span>{{ booking.hall | formatHall }}</span>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5 class="mb-4">
                        <v-subheader class="pa-0">Количество гостей</v-subheader>
                        <v-btn
                            icon
                            small
                            class="ma-0"
                            style="top: -2px;"
                            :disabled="booking.guest_count < 2"
                            :color="booking.guest_count < 2 ? '#DADADA' : '#2B65F0'"
                            @click="(booking.guest_count <= 99 && booking.guest_count > 1) ? booking.guest_count-- : ''">
                            <v-icon color="#fff">remove</v-icon>
                        </v-btn>
                        <span class="booking-guest-count_content">{{ booking.guest_count }}</span>
                        <v-btn
                            icon
                            small
                            class="ma-0"
                            style="top: -2px;"
                            :disabled="booking.guest_count > 98"
                            :color="booking.guest_count > 98 ? '#DADADA' : '#2B65F0'"
                            @click="(booking.guest_count >= 1 && booking.guest_count < 99) ? booking.guest_count++ : ''">
                            <v-icon color="#fff">add</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 class="mb-4">
                        <v-subheader class="pa-0">Комментарий</v-subheader>
                        <span>{{ booking.comment }}</span>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Booking from '../../../api/booking'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'editBooking',
        props: ['bookingId'],
        components: { Loader },
        data: () => ({
            loading: false,
            loader: false,
            booking: {
                id: 0,
                hall: 1,
                time: 0,
                state: 0,
                phone: '+998901234567',
                platform: 1,
                comment: '',
                customer: '',
                guest_count: 0,
                booking_id: 0,
                project_id: 0,
                customer_id: 0
            }
        }),
        mounted () {
            this.getBooking(this.bookingId)
        },
        methods: {
            getBooking (bookingId) {
                this.loader = true

                Booking
                    .getById(bookingId)
                    .then(response => {
                        this.booking = response.data.data
                        this.booking.time *= 1000
                    })
                    .catch(error => new Error(error))
                    .then(() => this.loader = false)
            },
            sendForm () {
                this.loading = true

                Booking
                    .edit({
                        id: this.booking.id,
                        guest_count: this.booking.guest_count
                    })
                    .then(response => this.$store.commit('showSnackbar', {
                        text: response.data.data,
                        color: 'success'
                    }))
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                    .finally(() => this.loading = false)
            },
            confirmRejectBooking (id, state) {
                this.loading = true

                Booking
                    .update({
                        id,
                        state
                    })
                    .then(response => {
                        this.booking = response.data.data
                        this.$store.commit('showSnackbar', {
                            text: 'Статус бронирование изменен успешно',
                            color: 'success'
                        });
                        this.$store.commit('changeBookingState', {
                            id,
                            state
                        });
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                    .finally(() => this.loading = false)
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.booking = this.getBooking(to.params.bookingId)
            next()
        }
    }
</script>

<style lang="scss">
    .booking {
        &-date,
        &-time {
            display: block;
            font: 400 14px / 22px 'Roboto';
        }

        &-guest-count {
            &_content {
                width: 20px;
                margin: 0 10px;
                text-align: center;
                display: inline-block;
            }
        }
    }
</style>
